// A role permission's name, "<role> - <permission>", once both have loaded;
// nothing until then, never "undefined - undefined" (audit F8).
export const permissionTitle = form => (form && form.roleName && form.identifier ? `${form.roleName} - ${form.identifier}` : '')
